module.exports = __webpack_public_path__ + "static/media/gnet.4681782d.jpeg";